module.exports = __webpack_public_path__ + "img/duanwu_ps_23.ede0556d.jpg";